import React from "react";
import Toast from "./Toast";
import styles from "./ToastContainer.module.css";

const ToastContainer = ({ toasts, removeToast }) => {
  return (
    <div className={styles.toastContainer}>
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          id={toast.id}
          message={toast.message}
          level={toast.level}
          autoDismiss={toast.autoDismiss}
          onClose={removeToast}
          color={toast.color}
        />
      ))}
    </div>
  );
};

export default ToastContainer;
